import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class EnlistmentService {

  //readonly rootUrl = "";
  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService) { }

  getSSGMasterList() {

    const autorization = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };

    return this.http.get(this.rootUrl + '/api/enlistment/getSSGMasterList', { headers: autorization });
  }


  getSMGMasterList() {

    const autorization = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };

    return this.http.get(this.rootUrl + '/api/enlistment/getSMGMasterList', { headers: autorization });
  }

  smgcategorysearch(keyword1) {
    const Key = {
      keyword: keyword1
    }
    const autorization = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    return this.http.post(this.rootUrl + '/api/enlistment/smgcategorysearch', Key, { headers: autorization });
  }

  registerVendorUser(form) {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.post(this.rootUrl + '/api/enlistment/registerVendorUser', form, requestOptions);

  }

  completeVendorRegistration(form) {
    return this.http.post(this.rootUrl + '/api/enlistment/completeVendorRegistration', form);
  }

  getEnlistmentFormsSsgSmg(enlistData) {
    return this.http.post(this.rootUrl + '/api/enlistment/getEnlistmentFormsSsgSmg', enlistData);
  }

  saveSmgManufacturerData(form) {
    return this.http.post(this.rootUrl + '/api/enlistment/saveSmgManufacturerData', form);
  }

  saveSmgDealerData(form) {
    return this.http.post(this.rootUrl + '/api/enlistment/saveSmgDealerData', form);
  }

  saveSsgDealerData(form) {
    return this.http.post(this.rootUrl + '/api/enlistment/saveSsgDealerData', form);
  }

  saveSsgContractorData(form) {
    return this.http.post(this.rootUrl + '/api/enlistment/saveSsgContractorData', form);
  }

  UploadVendorDocument(formData) {
    return this.http.post(this.rootUrl + '/api/enlistment/UploadVendorDocument', formData);
  }

  GetVendorDocs(formData) {
    return this.http.post(this.rootUrl + '/api/enlistment/GetVendorDocs', formData);
  }

  removeVendorDocs(id) {
    const doc = {
      docId: id
    }
    return this.http.post(this.rootUrl + '/api/enlistment/RemoveVendorDocs', doc);
  }

  ssgcategorysearch(keyword1) {
    const Key = {
      keyword: keyword1
    }
    const autorization = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    return this.http.post(this.rootUrl + '/api/enlistment/ssgcategorysearch', Key, { headers: autorization });
  }

  getStaticData() {

    const autorization = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };

    return this.http.get(this.rootUrl + '/api/account/Mktest', { headers: autorization });
  }

}
